import { observer } from "mobx-react-lite";
import { Fragment } from "react";
import {
  Button,
  ConfigProvider,
  Empty,
  Form,
  Modal,
  Select,
  Space,
  Upload,
  UploadProps,
  message,
} from "antd";
import {
  MyApplicationStore,
} from "../../../../store";
import { UploadOutlined } from "@ant-design/icons";

const addProps: UploadProps = {
  beforeUpload(info) {
    if (info.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || info.type === 'application/vnd.ms-excel') {
      return false
    } else {
      message.error("请上传xlsx格式");
      return Upload.LIST_IGNORE;
    }
  },
  onChange: (info) => {
    //删除文件时不提示上传成功
    if (info.file && (info.file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || info.file.type === 'application/vnd.ms-excel')&& info.fileList.length > 0) {
      MyApplicationStore.formData = info;
      message.success("上传成功");
    }else{
      //删除文件，清空
      MyApplicationStore.formData = null
    }
  },
};

function UpdateOrAdd(props: any) {
  const form = Form.useFormInstance();

  const submitPower = () => {
    if (MyApplicationStore.formData && MyApplicationStore.xpoolNo) {
      MyApplicationStore.addNumberModal = false
      MyApplicationStore.spinning = true
      MyApplicationStore.addPreview(MyApplicationStore.formData);
    }
  };

  const handleChange = (value: any, option: any)=>{
    MyApplicationStore.xpoolNo = value;
  }

  const getFormData = (
    changeValue: powerSearchData,
    allValues: powerSearchData
  ) => {
    MyApplicationStore.setSearchForm({ ...allValues });
  };

  const tableEmptyRender = () => {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={<>暂无数据</>}
      ></Empty>
    );
  };

  return (
    <Fragment>
      <Modal
        centered
        title={"新增X池号码(自带)"}
        open={MyApplicationStore.addNumberModal}
        destroyOnClose={true}
        onCancel={() => MyApplicationStore.controlAdd()}
        footer={null}
      >
        <div >
          <Form
            form={form}
            autoComplete="off"
            labelCol={{ span: 8 }}
            onValuesChange={getFormData}
            onFinish={submitPower}
          >
            <Form.Item
              label="请上传附件："
              name="upload"
              rules={[{ required: true, message: "请上传号码文件" }]}
              style={{width: "400px", marginBottom: "20px",}}
              valuePropName="fileList"
              getValueFromEvent={(e) => {
                if (Array.isArray(e)) {return e;}
                return e && e.fileList;
              }}
            >
              <Upload name="text" {...addProps} maxCount={1}>
                <Button icon={<UploadOutlined />}>上传号码文件</Button>
              </Upload>
            </Form.Item>
            <ConfigProvider renderEmpty={tableEmptyRender}>
            <Form.Item
              label="号池名称"
              name="name"
              rules={[{ required: true, message: "请选择号池" }]}
              style={{ width: "400px" }}
            >
              <Select
                placeholder="请选择号池"
                style={{ width: "272px", }}
                onChange={handleChange}
                showSearch
                allowClear={true}
                optionFilterProp="label"
                options={MyApplicationStore.getAllXPoolWriteInfo.map((item: any) => ({ value: item.no, label: item.name }))}
              >
              </Select>
            </Form.Item></ConfigProvider>
            <Form.Item
              style={{ textAlign: "right" }}
              wrapperCol={{ span: 18, offset: 6 }}
            >
              <Space>
                <Button
                  htmlType="reset"
                  onClick={() => MyApplicationStore.controlAdd()}
                >
                  取消
                </Button>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={MyApplicationStore.buttonLoading}
                >
                  确定
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </Fragment>
  );
}

export default observer(UpdateOrAdd);
